import script from "./VenueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueCard.vue?vue&type=script&setup=true&lang=js"

import "./VenueCard.vue?vue&type=style&index=0&id=dc01073c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc01073c"]])

export default __exports__